(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-shop-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Keep this list in sync with the wsp_pairs Liquid variable above (and
    // with wsp-locale-product-redirect.liquid / wsp-qxd-cart-guard.liquid,
    // which use the same CN:EN handle pairs elsewhere on the site).
    var WSP_PAIRS = [
      ['强心丹', 'qiang-xin-dan-en'],
      ['平干素', 'ping-gan-su-en'],
      ['降糖茶', 'gluco-lower-tea-en'],
      ['心肝配套', 'heart-liver-combo-en']
    ];

    function initCSG(root) {
      const sectionId = root.dataset.sectionId;
      const moneyFormat = root.dataset.moneyFormat || '{{amount}}';
      const limit = parseInt(root.dataset.limit || '20', 10);
      const locale = root.dataset.locale || '';

      let localeMap = {};
      const mapEl = root.querySelector('[data-csg-locale-map]');
      if (mapEl) {
        try {
          localeMap = JSON.parse(mapEl.textContent) || {};
        } catch (e) {
          localeMap = {};
        }
      }

      const sidebar = root.querySelector('#csg-sidebar-' + sectionId);
      const overlay = root.querySelector('[data-csg-overlay]');
      const catBtns = root.querySelectorAll('[data-csg-cat]');
      const sortSelects = root.querySelectorAll('[data-csg-sort]');
      const viewBtns = root.querySelectorAll('[data-csg-view]');
      const grid = root.querySelector('[data-csg-grid]');
      const loading = root.querySelector('[data-csg-loading]');
      const labelEl = root.querySelector('[data-csg-label]');
      const countEl = root.querySelector('[data-csg-count]');
      const emptyEl = root.querySelector('[data-csg-empty]');
      const drawerToggle = root.querySelector('[data-csg-drawer-toggle]');
      const drawerClose = sidebar && sidebar.querySelector('[data-csg-drawer-close]');

      let currentHandle = '';
      let currentSort = '';

      function formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return moneyFormat
          .replace('{{amount}}', amount)
          .replace('{{amount_with_comma_separator}}', amount)
          .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString());
      }

      function renderCard(rawProduct) {
        let product = rawProduct;

        // The locale map holds an entry keyed by whichever handle is
        // "wrong" for a given language (CN handle -> EN swap data, and
        // vice versa). Only ever swap the ONE direction that matches the
        // language currently being browsed, so an already-correct card is
        // never accidentally swapped to the other language.
        const isEnLocale = locale.indexOf('en') !== -1;
        let wrongHandle = null;
        for (let i = 0; i < WSP_PAIRS.length; i++) {
          const cnHandle = WSP_PAIRS[i][0];
          const enHandle = WSP_PAIRS[i][1];
          if (isEnLocale && rawProduct.handle === cnHandle) {
            wrongHandle = cnHandle;
            break;
          }
          if (!isEnLocale && rawProduct.handle === enHandle) {
            wrongHandle = enHandle;
            break;
          }
        }

        if (wrongHandle && rawProduct.handle === wrongHandle && localeMap[wrongHandle]) {
          const swap = localeMap[wrongHandle];
          product = Object.assign({}, rawProduct, {
            handle: swap.handle,
            title: swap.title,
            images: swap.image ? [{ src: swap.image, alt: swap.title }] : rawProduct.images,
            variants: [{
              price: swap.price != null ? String(swap.price) : (rawProduct.variants && rawProduct.variants[0] && rawProduct.variants[0].price),
              compare_at_price: swap.compare_at_price != null ? String(swap.compare_at_price) : null
            }]
          });
        }

        const image = product.images && product.images[0];
        const imgSrc = image
          ? image.src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_400x$1')
          : '';
        const imgAlt = (image && image.alt) || product.title;

        const variant = product.variants && product.variants[0];
        const price = variant ? Math.round(parseFloat(variant.price) * 100) : 0;
        const compare = variant && variant.compare_at_price
          ? Math.round(parseFloat(variant.compare_at_price) * 100)
          : 0;

        const tags = Array.isArray(product.tags)
          ? product.tags
          : (product.tags || '').split(',').map(function (t) { return t.trim(); });
        const isNew = tags.some(function (t) { return t.toLowerCase() === 'new'; });
        const isTop = tags.some(function (t) {
          return ['top-sales', 'top sales', 'topsales'].indexOf(t.toLowerCase()) !== -1;
        });

        const badges = [
          isNew ? '<span class="csg-badge csg-badge--new">New!</span>' : '',
          isTop ? '<span class="csg-badge csg-badge--top">TOP SALES</span>' : ''
        ].join('');

        const imgHtml = imgSrc
          ? '<img src="' + imgSrc + '" alt="' + imgAlt.replace(/"/g, '&quot;') + '" loading="lazy" class="csg-card__img">'
          : '<div class="csg-card__img-placeholder"></div>';

        const priceHtml = compare > price
          ? '<span class="csg-price--sale">' + formatMoney(price) + '</span><s class="csg-price--compare">' + formatMoney(compare) + '</s>'
          : '<span>' + formatMoney(price) + '</span>';

        const title = product.title.length > 60
          ? product.title.slice(0, 57) + '...'
          : product.title;

        return '<article class="csg-card"><a href="/products/' + product.handle + '" class="csg-card__link">'
          + '<div class="csg-card__media">' + imgHtml
          + (badges ? '<div class="csg-card__badges" aria-hidden="true">' + badges + '</div>' : '')
          + '</div><div class="csg-card__body">'
          + '<p class="csg-card__title">' + title + '</p>'
          + '<div class="csg-card__price">' + priceHtml + '</div>'
          + '</div></a></article>';
      }

      async function loadProducts() {
        if (!grid) return;
        loading && loading.classList.add('is-active');

        try {
          let url;
          if (currentHandle) {
            url = '/collections/' + currentHandle + '/products.json?limit=' + limit;
            if (currentSort) url += '&sort_by=' + currentSort;
          } else {
            url = '/products.json?limit=' + limit;
            const allSortMap = {
              'price-ascending': 'price',
              'best-selling': 'best-selling',
              'created-descending': 'created-at'
            };
            if (currentSort && allSortMap[currentSort]) {
              url += '&sort_by=' + allSortMap[currentSort];
            }
          }

          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('HTTP ' + res.status);

          const data = await res.json();
          let products = data.products || [];

          /* client-side price-desc for /products.json since API doesn't support descending */
          if (!currentHandle && currentSort === 'price-descending') {
            products = products.slice().sort(function (a, b) {
              return parseFloat(b.variants[0] && b.variants[0].price || 0)
                - parseFloat(a.variants[0] && a.variants[0].price || 0);
            });
          }

          if (products.length === 0) {
            grid.innerHTML = '';
            emptyEl && emptyEl.classList.add('is-visible');
          } else {
            emptyEl && emptyEl.classList.remove('is-visible');
            grid.innerHTML = products
              .map(function (p) { return '<li class="csg-grid__item">' + renderCard(p) + '</li>'; })
              .join('');
          }

          if (countEl) countEl.textContent = products.length ? '(' + products.length + ')' : '';
        } catch (err) {
          console.error('[custom-shop-grid]', err);
        } finally {
          loading && loading.classList.remove('is-active');
        }
      }

      catBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          catBtns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          currentHandle = btn.dataset.handle;
          if (labelEl) labelEl.textContent = btn.dataset.label;

          loadProducts();
          closeSidebar();
        });
      });

      sortSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          currentSort = sel.value;
          sortSelects.forEach(function (s) { s.value = currentSort; });
          loadProducts();
        });
      });

      viewBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          viewBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (grid) grid.setAttribute('data-view', btn.dataset.csgView);
        });
      });

      function openSidebar() {
        if (!sidebar) return;
        sidebar.setAttribute('data-open', 'true');
        overlay && overlay.setAttribute('data-open', 'true');
        drawerToggle && drawerToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeSidebar() {
        if (!sidebar) return;
        sidebar.setAttribute('data-open', 'false');
        overlay && overlay.setAttribute('data-open', 'false');
        drawerToggle && drawerToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      drawerToggle && drawerToggle.addEventListener('click', function () {
        sidebar.getAttribute('data-open') === 'true' ? closeSidebar() : openSidebar();
      });

      drawerClose && drawerClose.addEventListener('click', closeSidebar);
      overlay && overlay.addEventListener('click', closeSidebar);
    }

    function initAll() {
      document.querySelectorAll('.csg-section').forEach(initCSG);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mid-autumn-mix-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mid-autumn-mix-selector')) customElements.define('mid-autumn-mix-selector', class extends HTMLElement {
    connectedCallback(){this.cards=[...this.querySelectorAll('[data-role="product"]')];this.submit=this.querySelector('[data-role="submit"]');this.error=this.querySelector('[data-role="error"]');this.addEventListener('click',event=>{const action=event.target.dataset.action;if(!action)return;const input=event.target.closest('.mid-builder__stepper').querySelector('input');input.value=Number(input.value)+(action==='plus'?1:-1);this.normalize(input);this.update()});this.addEventListener('input',event=>{if(!event.target.matches('input'))return;this.normalize(event.target);this.update()});this.submit.addEventListener('click',()=>this.add());this.update()}
    normalize(changedInput){changedInput.value=Math.max(0,Math.floor(Number(changedInput.value)||0))}
    selection(){return this.cards.map(card=>({id:Number(card.dataset.variantId),price:Number(card.dataset.price),quantity:Number(card.querySelector('input').value)||0})).filter(item=>item.quantity>0)}
    money(cents){return `RM${(cents/100).toFixed(2)}`}
    copy(key,replacements={}){let value=this.dataset[key]||'';Object.entries(replacements).forEach(([token,replacement])=>{value=value.replace(`[${token}]`,replacement)});return value}
    update(){const items=this.selection();const count=items.reduce((sum,item)=>sum+item.quantity,0);this.cards.forEach(card=>{const input=card.querySelector('input');card.querySelector('[data-action="minus"]').disabled=Number(input.value)<=0;card.querySelector('[data-action="plus"]').disabled=false});const subtotal=items.reduce((sum,item)=>sum+item.price*item.quantity,0);const factor=count===2?.92:count>=3?.92*.85:1;const total=items.reduce((sum,item)=>sum+Math.round(item.price*factor)*item.quantity,0);this.querySelector('[data-role="count"]').textContent=this.copy('itemCount',{count});this.querySelector('[data-role="subtotal"]').textContent=this.money(subtotal);this.querySelector('[data-role="saving"]').textContent=`− ${this.money(subtotal-total)}`;this.querySelector('[data-role="total"]').textContent=this.money(total);this.querySelector('[data-role="prompt"]').textContent=count===1?this.copy('regularPrice'):count===2?this.copy('eightOff'):count>=3?this.copy('stackedOff'):this.copy('selectOne');const thresholds=[18000,25000,35000],next=thresholds.find(value=>total<value),target=next||35000;this.querySelector('[data-role="progress"]').style.width=`${Math.min(100,total/target*100)}%`;const title=this.querySelector('[data-role="gift-title"]'),copy=this.querySelector('[data-role="gift-next"]');if(total>=35000){title.textContent=this.copy('unlocked350');copy.textContent=this.copy('gifts350')}else if(total>=25000){title.textContent=this.copy('unlocked250');copy.textContent=this.copy('upgradeHighest',{amount:this.money(35000-total)})}else if(total>=18000){title.textContent=this.copy('unlocked180');copy.textContent=this.copy('upgradeGift',{amount:this.money(25000-total)})}else{title.textContent=this.copy('unlockGifts');copy.textContent=this.copy('amountTo180',{amount:this.money(18000-total)})}this.submit.disabled=count<1}
    async add(){const items=this.selection().map(({id,quantity})=>({id,quantity}));if(!items.length)return;this.submit.disabled=true;this.error.hidden=true;try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});if(!response.ok)throw new Error();const itemCount=items.reduce((sum,item)=>sum+item.quantity,0);if(window.WSPRefreshAndOpenCartDrawer){await window.WSPRefreshAndOpenCartDrawer({sourceId:'mid-autumn-mix-selector',itemCount})}else{document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:{},sourceId:'mid-autumn-mix-selector',data:{}}}));document.querySelector('cart-drawer-component')?.open?.()}this.submit.disabled=false}catch(error){this.error.textContent=this.copy('addError');this.error.hidden=false;this.submit.disabled=false}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samlaunch-wsp-testimonial-videos"] && !Shopify.designMode) return;
  try {
    
  class WspTestimonialLightbox extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.wsp-video-card'));
      this.clickableCards = this.cards.filter((card) => card.dataset.videoUrl);
      this.lightbox = this.querySelector('.wsp-lightbox');

      this.initSlider();
      this.initPreviewAutoplay();

      if (!this.lightbox || !this.clickableCards.length) return;

      this.overlay = this.lightbox.querySelector('.wsp-lightbox__overlay');
      this.closeBtn = this.lightbox.querySelector('.wsp-lightbox__close');
      this.prevBtn = this.lightbox.querySelector('.wsp-lightbox__nav--prev');
      this.nextBtn = this.lightbox.querySelector('.wsp-lightbox__nav--next');
      this.player = this.lightbox.querySelector('.wsp-lightbox__player');
      this.nameEl = this.lightbox.querySelector('.wsp-lightbox__name');
      this.descEl = this.lightbox.querySelector('.wsp-lightbox__desc');
      this.currentVideoIndex = 0;

      this.clickableCards.forEach((card, index) => {
        card.addEventListener('click', () => this.open(index));
      });

      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());
      this.prevBtn.addEventListener('click', () => this.showVideo(this.currentVideoIndex - 1));
      this.nextBtn.addEventListener('click', () => this.showVideo(this.currentVideoIndex + 1));

      this._onKeydown = (event) => {
        if (this.lightbox.hidden) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.showVideo(this.currentVideoIndex - 1);
        if (event.key === 'ArrowRight') this.showVideo(this.currentVideoIndex + 1);
      };
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
      this.previewObserver?.disconnect();
    }

    /* Mobile 1-at-a-time swipe slider: no arrows/dots, native touch swipe only.
       A clone of the first card is appended after the last so swiping past
       the end continues into a repeat of the first, then silently snaps
       back to the real first card for a seamless forward loop. */
    initSlider() {
      this.track = this.querySelector('.wsp-testimonials__grid');
      if (!this.track || !this.cards.length) return;

      const firstCard = this.track.firstElementChild;
      if (firstCard) {
        const clone = firstCard.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        if (clone.dataset && clone.dataset.videoUrl) {
          clone.addEventListener('click', () => this.open(0));
        }
        this.track.appendChild(clone);
        this.loopClone = clone;
      }

      this.track.addEventListener('scroll', () => this.onSliderScroll(), { passive: true });
      const controls = this.querySelector('.wsp-video-swipe-controls');
      if (controls) {
        this.swipeCount = controls.querySelector('[data-swipe-count]');
        this.sliderIndex = 0;
        const move = (delta) => {
          const index = (this.sliderIndex + delta + this.cards.length) % this.cards.length;
          const target = this.cards[index];
          const left = this.track.scrollLeft + target.getBoundingClientRect().left - this.track.getBoundingClientRect().left - parseFloat(getComputedStyle(this.track).paddingLeft || 0);
          this.track.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        controls.querySelector('[data-swipe-prev]').addEventListener('click', () => move(-1));
        controls.querySelector('[data-swipe-next]').addEventListener('click', () => move(1));
        this.updateSwipeCount();
      }
    }

    updateSwipeCount() {
      if (!this.swipeCount) return;
      const edge = this.track.getBoundingClientRect().left + parseFloat(getComputedStyle(this.track).paddingLeft || 0);
      let best = Infinity;
      this.cards.forEach((card, index) => { const distance = Math.abs(card.getBoundingClientRect().left - edge); if (distance < best) { best = distance; this.sliderIndex = index; } });
      if (this.loopClone && Math.abs(this.loopClone.getBoundingClientRect().left - edge) < best) this.sliderIndex = 0;
      const label = (this.sliderIndex + 1) + " / " + this.cards.length;
      if (this.swipeCount.textContent !== label) this.swipeCount.textContent = label;
    }

    onSliderScroll() {
      window.clearTimeout(this._sliderScrollTimeout);
      this._sliderScrollTimeout = window.setTimeout(() => { this.checkLoop(); this.updateSwipeCount(); }, 150);
    }

    checkLoop() {
      if (!this.loopClone) return;
      const trackRect = this.track.getBoundingClientRect();
      const cloneRect = this.loopClone.getBoundingClientRect();
      if (Math.abs(cloneRect.left - trackRect.left) < trackRect.width * 0.5) {
        this.track.scrollTo({ left: 0, behavior: 'instant' });
      }
    }

    /* The autoplay=1 param in each preview iframe's src only fires once, at
       load time. On desktop's grid every card is on-screen simultaneously so
       they all autoplay fine, but on the mobile swipe slider only the first
       card is actually visible at load - the rest are off-screen and get
       throttled/paused by the browser before the visitor ever swipes to
       them, with nothing to resume them. This explicitly (re)plays a card's
       video via the YouTube postMessage API whenever it scrolls into view,
       and pauses it when it scrolls out (saving data/battery on the ones
       that aren't visible).
    */
    initPreviewAutoplay() {
      this.previewFrames = this.cards
        .map((card) => card.querySelector('.wsp-video-card__preview'))
        .filter(Boolean);
      if (!this.previewFrames.length || !('IntersectionObserver' in window)) return;

      this.previewObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const command = entry.isIntersecting ? 'playVideo' : 'pauseVideo';
            this.postPlayerCommand(entry.target, command);
            if (entry.isIntersecting) this.postPlayerCommand(entry.target, 'mute');
          });
        },
        { threshold: 0.6 }
      );

      this.previewFrames.forEach((iframe) => this.previewObserver.observe(iframe));
    }

    postPlayerCommand(iframe, func) {
      if (!iframe.contentWindow) return;
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func, args: '' }), '*');
    }

    /* Lightbox */
    open(index) {
      this.showVideo(index);
      this.lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.player.innerHTML = '';
      this.lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    showVideo(index) {
      const total = this.clickableCards.length;
      index = (index + total) % total;
      this.currentVideoIndex = index;
      const card = this.clickableCards[index];

      const videoUrl = card.dataset.videoUrl || '';
      const name = card.dataset.customerName || '';
      const caption = card.dataset.caption || '';

      this.player.innerHTML = '';
      const embedUrl = this.toEmbedUrl(videoUrl);
      if (embedUrl) {
        const iframe = document.createElement('iframe');
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.src = embedUrl;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        this.player.appendChild(iframe);
      } else {
        const message = document.createElement('p');
        message.className = 'wsp-lightbox__no-video';
        message.textContent = this.dataset.videoUnavailableText || 'Video unavailable';
        this.player.appendChild(message);
      }

      this.nameEl.textContent = name;
      this.descEl.textContent = caption;
    }

    toEmbedUrl(url) {
      if (!url) return null;
      const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
      if (match) {
        // Muted here even though opening the lightbox is a user click/gesture:
        // unmuted autoplay inside a cross-origin iframe is unreliable on
        // mobile Safari and in-app WebViews (the click on the parent page
        // doesn't reliably count as "activation" inside the iframe), so it
        // can silently fail to play until a second manual tap. Muted
        // autoplay is honored everywhere, and controls are left on so the
        // viewer can unmute with one tap.
        return 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&mute=1&playsinline=1&rel=0&origin=' + encodeURIComponent(window.location.origin);
      }
      return null;
    }
  }

  if (!customElements.get('wsp-testimonial-lightbox')) {
    customElements.define('wsp-testimonial-lightbox', WspTestimonialLightbox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-heart-risks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wsp-heart-risks')) {
  customElements.define('wsp-heart-risks', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => tab.addEventListener('click', () => {
        this.tabs.forEach((item, itemIndex) => item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false'));
        this.panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== index; });
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-heart-symptoms"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wsp-heart-symptoms')) {
    customElements.define('wsp-heart-symptoms', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.stage = this.querySelector('[data-stage]');
        const hover = window.matchMedia('(hover: hover) and (min-width: 990px)');
        this.tabs.forEach((t, i) => {
          t.addEventListener('mouseenter', () => { if (hover.matches) this.show(i); });
          t.addEventListener('focus', () => this.show(i));
          t.addEventListener('click', () => {
            this.show(i);
            if (!hover.matches && this.stage) {
              const r = this.stage.getBoundingClientRect();
              if (r.top > window.innerHeight * 0.55 || r.top < 0) this.stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
          t.addEventListener('keydown', (e) => {
            const map = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            if (!(e.key in map)) return;
            e.preventDefault();
            this.tabs[(i + map[e.key] + this.tabs.length) % this.tabs.length].focus();
          });
        });
      }
      show(i) {
        this.tabs.forEach((t, j) => {
          const on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const p = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-jtc-herbs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wsp-qxd-herbs')) {
    customElements.define('wsp-qxd-herbs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.stage = this.querySelector('[data-stage]');
        this.grid = this.querySelector('.wsp-jhb__grid');
        this.syncStageHeight = () => {
          if (!this.grid || !this.stage) return;
          if (window.matchMedia('(min-width: 990px)').matches) {
            this.style.setProperty('--wsp-jhb-stage-height', `${this.grid.offsetHeight}px`);
          } else {
            this.style.removeProperty('--wsp-jhb-stage-height');
          }
        };
        requestAnimationFrame(this.syncStageHeight);
        if (window.ResizeObserver && this.grid) {
          this.resizeObserver = new ResizeObserver(this.syncStageHeight);
          this.resizeObserver.observe(this.grid);
        } else {
          window.addEventListener('resize', this.syncStageHeight);
        }
        const hover = window.matchMedia('(hover: hover) and (min-width: 990px)');
        this.tabs.forEach((t, i) => {
          t.addEventListener('mouseenter', () => { if (hover.matches) this.show(i); });
          t.addEventListener('focus', () => this.show(i));
          t.addEventListener('click', () => {
            this.show(i);
            if (!hover.matches && this.stage) {
              const r = this.stage.getBoundingClientRect();
              if (r.top > window.innerHeight * 0.6 || r.top < 0) this.stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
          t.addEventListener('keydown', (e) => {
            const map = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            if (!(e.key in map)) return;
            e.preventDefault();
            const n = (i + map[e.key] + this.tabs.length) % this.tabs.length;
            this.tabs[n].focus();
          });
        });
      }
      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        else window.removeEventListener('resize', this.syncStageHeight);
      }
      show(i) {
        this.tabs.forEach((t, j) => {
          const on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const p = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-qxd-check"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wsp-qxd-check')) {
    customElements.define('wsp-qxd-check', class extends HTMLElement {
      connectedCallback() {
        this.side = this.querySelector('[data-side]');
        this.empty = this.querySelector('[data-empty]');
        this.res = this.querySelectorAll('[data-r]');
        this.addEventListener('change', (e) => {
          if (!e.target.matches('input[type="radio"]')) return;
          const v = e.target.value;
          this.empty.hidden = true;
          this.res.forEach((r) => { r.hidden = r.dataset.r !== v; });
          if (window.matchMedia('(max-width: 989px)').matches) {
            this.side.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-qxd-herbs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wsp-qxd-herbs')) {
    customElements.define('wsp-qxd-herbs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.stage = this.querySelector('[data-stage]');
        this.grid = this.querySelector('.wsp-qhb__grid');
        this.syncStageHeight = () => {
          if (!this.grid || !this.stage) return;
          if (window.matchMedia('(min-width: 990px)').matches) {
            this.style.setProperty('--wsp-qhb-stage-height', `${this.grid.offsetHeight}px`);
          } else {
            this.style.removeProperty('--wsp-qhb-stage-height');
          }
        };
        requestAnimationFrame(this.syncStageHeight);
        if (window.ResizeObserver && this.grid) {
          this.resizeObserver = new ResizeObserver(this.syncStageHeight);
          this.resizeObserver.observe(this.grid);
        } else {
          window.addEventListener('resize', this.syncStageHeight);
        }
        const hover = window.matchMedia('(hover: hover) and (min-width: 990px)');
        this.tabs.forEach((t, i) => {
          t.addEventListener('mouseenter', () => { if (hover.matches) this.show(i); });
          t.addEventListener('focus', () => this.show(i));
          t.addEventListener('click', () => {
            this.show(i);
            if (!hover.matches && this.stage) {
              const r = this.stage.getBoundingClientRect();
              if (r.top > window.innerHeight * 0.6 || r.top < 0) this.stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
          t.addEventListener('keydown', (e) => {
            const map = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            if (!(e.key in map)) return;
            e.preventDefault();
            const n = (i + map[e.key] + this.tabs.length) % this.tabs.length;
            this.tabs[n].focus();
          });
        });
      }
      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        else window.removeEventListener('resize', this.syncStageHeight);
      }
      show(i) {
        this.tabs.forEach((t, j) => {
          const on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const p = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-qxd-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wsp-stories-slider')) {
    customElements.define('wsp-stories-slider', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.nextButton = this.querySelector('[data-next]');
        this.prevButton = this.querySelector('[data-prev]');
        this.impactCounter = this.closest('.wsp2-stories')?.querySelector('[data-impact-count]');
        if (!this.viewport || !this.track) return;
        this.offset = 0;
        this.extra = 0;
        this.dragging = false;
        this.lastTime = performance.now();
        this.cards = Array.from(this.track.querySelectorAll('.wsp2-stories__card'));
        this.measure = this.measure.bind(this);
        this.tick = this.tick.bind(this);
        this.measure();
        window.addEventListener('resize', this.measure);
        this.nextButton?.addEventListener('click', () => { this.extra += this.step; });
        this.prevButton?.addEventListener('click', () => { this.extra -= this.step; });
        if (this.impactCounter) this.startImpactCounter();
        this.viewport.addEventListener('pointerdown', (event) => {
          this.dragging = true;
          this.startX = event.clientX;
          this.startOffset = this.offset;
          this.viewport.setPointerCapture(event.pointerId);
        });
        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.dragging) return;
          this.offset = this.startOffset - (event.clientX - this.startX);
          this.normalize();
        });
        const endDrag = () => { this.dragging = false; };
        this.viewport.addEventListener('pointerup', endDrag);
        this.viewport.addEventListener('pointercancel', endDrag);
        requestAnimationFrame(this.tick);
      }
      measure() {
        const halfway = Math.floor(this.cards.length / 2);
        this.loopWidth = this.cards[halfway]?.offsetLeft - this.cards[0]?.offsetLeft || 1;
        this.step = this.cards[1]?.offsetLeft - this.cards[0]?.offsetLeft || 1;
        this.normalize();
      }
      normalize() {
        while (this.offset >= this.loopWidth) this.offset -= this.loopWidth;
        while (this.offset < 0) this.offset += this.loopWidth;
      }
      tick(time) {
        const elapsed = Math.min(time - this.lastTime, 64);
        this.lastTime = time;
        if (!this.dragging && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const nudge = Math.sign(this.extra) * Math.min(Math.abs(this.extra), 28);
          this.extra -= nudge;
          this.offset += elapsed * 0.028 + nudge;
          this.normalize();
        }
        this.track.style.transform = 'translate3d(' + (-this.offset) + 'px,0,0)';
        this.frame = requestAnimationFrame(this.tick);
      }
      startImpactCounter() {
        const target = Number(this.impactCounter.dataset.countTarget) || 0;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
          this.impactCounter.textContent = target.toLocaleString('en-US');
          return;
        }
        const duration = 2400;
        const startedAt = performance.now();
        const countUp = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = Math.min(target, Math.floor(target * eased));
          this.impactCounter.textContent = value.toLocaleString('en-US');
          if (progress < 1) {
            this.impactFrame = requestAnimationFrame(countUp);
            return;
          }
          let current = target;
          this.impactCounter.textContent = current.toLocaleString('en-US');
          this.impactTimer = window.setInterval(() => {
            current += 1;
            this.impactCounter.textContent = current.toLocaleString('en-US');
          }, 2500);
        };
        this.impactCounter.textContent = '0';
        this.impactFrame = requestAnimationFrame(countUp);
      }
      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.impactFrame) cancelAnimationFrame(this.impactFrame);
        if (this.impactTimer) window.clearInterval(this.impactTimer);
        window.removeEventListener('resize', this.measure);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-qxd-symptoms"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wsp-qxd-symptoms')) {
    customElements.define('wsp-qxd-symptoms', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.stage = this.querySelector('[data-stage]');
        const hover = window.matchMedia('(hover: hover) and (min-width: 990px)');
        this.tabs.forEach((t, i) => {
          t.addEventListener('mouseenter', () => { if (hover.matches) this.show(i); });
          t.addEventListener('focus', () => this.show(i));
          t.addEventListener('click', () => {
            this.show(i);
            if (!hover.matches && this.stage) {
              const r = this.stage.getBoundingClientRect();
              if (r.top > window.innerHeight * 0.55 || r.top < 0) this.stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
          t.addEventListener('keydown', (e) => {
            const map = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            if (!(e.key in map)) return;
            e.preventDefault();
            this.tabs[(i + map[e.key] + this.tabs.length) % this.tabs.length].focus();
          });
        });
      }
      show(i) {
        this.tabs.forEach((t, j) => {
          const on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const p = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-testimonial-videos"] && !Shopify.designMode) return;
  try {
    
  class WspTestimonialLightbox extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.wsp-video-card'));
      this.clickableCards = this.cards.filter((card) => card.dataset.videoUrl);
      this.lightbox = this.querySelector('.wsp-lightbox');

      this.initSlider();
      this.initPreviewAutoplay();

      if (!this.lightbox || !this.clickableCards.length) return;

      this.overlay = this.lightbox.querySelector('.wsp-lightbox__overlay');
      this.closeBtn = this.lightbox.querySelector('.wsp-lightbox__close');
      this.prevBtn = this.lightbox.querySelector('.wsp-lightbox__nav--prev');
      this.nextBtn = this.lightbox.querySelector('.wsp-lightbox__nav--next');
      this.player = this.lightbox.querySelector('.wsp-lightbox__player');
      this.nameEl = this.lightbox.querySelector('.wsp-lightbox__name');
      this.descEl = this.lightbox.querySelector('.wsp-lightbox__desc');
      this.currentVideoIndex = 0;

      this.clickableCards.forEach((card, index) => {
        card.addEventListener('click', () => this.open(index));
      });

      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());
      this.prevBtn.addEventListener('click', () => this.showVideo(this.currentVideoIndex - 1));
      this.nextBtn.addEventListener('click', () => this.showVideo(this.currentVideoIndex + 1));

      this._onKeydown = (event) => {
        if (this.lightbox.hidden) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.showVideo(this.currentVideoIndex - 1);
        if (event.key === 'ArrowRight') this.showVideo(this.currentVideoIndex + 1);
      };
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
      this.previewObserver?.disconnect();
    }

    /* Mobile 1-at-a-time swipe slider: no arrows/dots, native touch swipe only.
       A clone of the first card is appended after the last so swiping past
       the end continues into a repeat of the first, then silently snaps
       back to the real first card for a seamless forward loop. */
    initSlider() {
      this.track = this.querySelector('.wsp-testimonials__grid');
      if (!this.track || !this.cards.length) return;

      const firstCard = this.track.firstElementChild;
      if (firstCard) {
        const clone = firstCard.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        if (clone.dataset && clone.dataset.videoUrl) {
          clone.addEventListener('click', () => this.open(0));
        }
        this.track.appendChild(clone);
        this.loopClone = clone;
      }

      this.track.addEventListener('scroll', () => this.onSliderScroll(), { passive: true });
    }

    onSliderScroll() {
      window.clearTimeout(this._sliderScrollTimeout);
      this._sliderScrollTimeout = window.setTimeout(() => this.checkLoop(), 150);
    }

    checkLoop() {
      if (!this.loopClone) return;
      const trackRect = this.track.getBoundingClientRect();
      const cloneRect = this.loopClone.getBoundingClientRect();
      if (Math.abs(cloneRect.left - trackRect.left) < trackRect.width * 0.5) {
        this.track.scrollTo({ left: 0, behavior: 'instant' });
      }
    }

    /* The autoplay=1 param in each preview iframe's src only fires once, at
       load time. On desktop's grid every card is on-screen simultaneously so
       they all autoplay fine, but on the mobile swipe slider only the first
       card is actually visible at load - the rest are off-screen and get
       throttled/paused by the browser before the visitor ever swipes to
       them, with nothing to resume them. This explicitly (re)plays a card's
       video via the YouTube postMessage API whenever it scrolls into view,
       and pauses it when it scrolls out (saving data/battery on the ones
       that aren't visible).
    */
    initPreviewAutoplay() {
      this.previewFrames = this.cards
        .map((card) => card.querySelector('.wsp-video-card__preview'))
        .filter(Boolean);
      if (!this.previewFrames.length || !('IntersectionObserver' in window)) return;

      this.previewObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const command = entry.isIntersecting ? 'playVideo' : 'pauseVideo';
            this.postPlayerCommand(entry.target, command);
            if (entry.isIntersecting) this.postPlayerCommand(entry.target, 'mute');
          });
        },
        { threshold: 0.6 }
      );

      this.previewFrames.forEach((iframe) => this.previewObserver.observe(iframe));
    }

    postPlayerCommand(iframe, func) {
      if (!iframe.contentWindow) return;
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func, args: '' }), '*');
    }

    /* Lightbox */
    open(index) {
      this.showVideo(index);
      this.lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.player.innerHTML = '';
      this.lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    showVideo(index) {
      const total = this.clickableCards.length;
      index = (index + total) % total;
      this.currentVideoIndex = index;
      const card = this.clickableCards[index];

      const videoUrl = card.dataset.videoUrl || '';
      const name = card.dataset.customerName || '';
      const caption = card.dataset.caption || '';

      this.player.innerHTML = '';
      const embedUrl = this.toEmbedUrl(videoUrl);
      if (embedUrl) {
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        this.player.appendChild(iframe);
      } else {
        const message = document.createElement('p');
        message.className = 'wsp-lightbox__no-video';
        message.textContent = this.dataset.videoUnavailableText || 'Video unavailable';
        this.player.appendChild(message);
      }

      this.nameEl.textContent = name;
      this.descEl.textContent = caption;
    }

    toEmbedUrl(url) {
      if (!url) return null;
      const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
      if (match) {
        // Muted here even though opening the lightbox is a user click/gesture:
        // unmuted autoplay inside a cross-origin iframe is unreliable on
        // mobile Safari and in-app WebViews (the click on the parent page
        // doesn't reliably count as "activation" inside the iframe), so it
        // can silently fail to play until a second manual tap. Muted
        // autoplay is honored everywhere, and controls are left on so the
        // viewer can unmute with one tap.
        return 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&mute=1&playsinline=1&rel=0';
      }
      return null;
    }
  }

  if (!customElements.get('wsp-testimonial-lightbox')) {
    customElements.define('wsp-testimonial-lightbox', WspTestimonialLightbox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  class WspTestimonialSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.wsp-testi-slider__track');
      this.prevBtn = this.querySelector('.wsp-testi-slider__arrow--prev');
      this.nextBtn = this.querySelector('.wsp-testi-slider__arrow--next');
      if (!this.track) return;

      this.prevBtn.addEventListener('click', () => {
        this.stopAutoscroll();
        this.scrollByPage(-1);
      });
      this.nextBtn.addEventListener('click', () => {
        this.stopAutoscroll();
        this.scrollByPage(1);
      });

      if (this.dataset.autoscroll === 'true') {
        this.startAutoscroll();
        this.addEventListener('mouseenter', () => this.stopAutoscroll());
        this.addEventListener('mouseleave', () => this.startAutoscroll());
      }
    }

    disconnectedCallback() {
      this.stopAutoscroll();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    startAutoscroll() {
      this.stopAutoscroll();
      this._autoscrollTimer = window.setInterval(() => {
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
        if (atEnd) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollByPage(1);
        }
      }, 5000);
    }

    stopAutoscroll() {
      if (this._autoscrollTimer) {
        window.clearInterval(this._autoscrollTimer);
        this._autoscrollTimer = null;
      }
    }
  }

  if (!customElements.get('wsp-testimonial-slider')) {
    customElements.define('wsp-testimonial-slider', WspTestimonialSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsp-v2-self-test"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wsp-self-test')) {
    customElements.define('wsp-self-test', class extends HTMLElement {
      connectedCallback() {
        this.tiers = JSON.parse(this.querySelector('[data-tiers]').textContent);
        this.addEventListener('change', () => this.update());
        this.querySelector('[data-pick-tier]').addEventListener('click', () => this.pick());
      }
      val(n) { const el = this.querySelector(`input[name^="wsp-q${n}-"]:checked`); return el ? el.value : null; }
      update() {
        const q1 = this.val(1), q2 = this.val(2), q3 = this.val(3);
        if (!q1 || !q2 || !q3) return;
        this.querySelector('.wsp2-test__empty').hidden = true;
        this.querySelector('.wsp2-test__out').hidden = false;
        this.querySelectorAll('[data-result]').forEach((el) => { el.hidden = el.dataset.result !== q1; });
        this.querySelector('.wsp2-test__family').hidden = q2 !== 'family';
        this.querySelector('.wsp2-test__warn').hidden = q3 !== 'yes';
        this.tierIndex = this.tiers[q1];
        const tier = document.querySelectorAll('.wsp2-tier')[this.tierIndex - 1];
        const label = tier ? (tier.dataset.label || '') : '';
        this.querySelector('[data-tier-label]').textContent = label.trim() || `第 ${this.tierIndex} 档`;
      }
      pick() {
        const tier = document.querySelectorAll('.wsp2-tier')[(this.tierIndex || 1) - 1];
        if (tier) {
          tier.click();
          tier.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
